import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchGetAdminSettings } from '../../../../actions/admin';
import { v4 as uuidv4 } from 'uuid';
import InputWrapper from '../../../common/InputWrapper';
import Checkbox from '../../../common/Checkbox';
import { preventSubmittingByEnter } from '../../../../helpers';
import Select from '../../../common/Select';

const AdminSettings = (props) => {
  const { values, handleChangeInput, handleSubmit } = props;
  const dispatch = useDispatch();
  const { settings } = useSelector((state) => state.admin);

  useEffect(() => {
    dispatch(fetchGetAdminSettings());
  }, []);

  const handleUpdateCheckbox = (e) => handleChangeInput(e.target.id, e.target.checked);

  const VAT_OPTIONS = [
    { value: 'NO_VAT', label: 'NO_VAT' },
    { value: 'VAT_0', label: 'VAT_0' },
    { value: 'VAT_10', label: 'VAT_10' },
    { value: 'VAT_18', label: 'VAT_18' },
    { value: 'VAT_20', label: 'VAT_20' },
  ];

  const renderSettings = (item) => {
    return (
      <>
        <section style={{ marginTop: '16px' }}>
          <div className="row">
            <div className="col-6">
              <div className="form-group">
                <InputWrapper
                  id="clientNumber"
                  label="clientNumber"
                  value={values.lite?.clientNumber}
                  onChange={(e) => handleChangeInput('clientNumber', e.target.value)}
                />
              </div>
              <div className="form-group">
                <Select
                  label="Регион бесплатной доставки"
                  options={VAT_OPTIONS}
                  value={VAT_OPTIONS.find((o) => o.value === values.lite?.defaultVat)}
                  onChange={({ value }) => handleChangeInput(`defaultVat`, value)}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="form-group">
                <Checkbox
                  id="b2bFlagAllowed"
                  checked={values.lite?.b2bFlagAllowed}
                  label={'b2bFlagAllowed'}
                  /*Не представлен в форме*/
                />
              </div>
              <div className="form-group">
                <Checkbox
                  id="businessTariff"
                  onChange={handleUpdateCheckbox}
                  checked={values.lite?.businessTariff}
                  label={'businessTariff'}
                />
              </div>
              <div className="form-group">
                <Checkbox
                  id="commercialAccount"
                  checked={values.lite?.commercialAccount}
                  label={'commercialAccount'}
                  onChange={handleUpdateCheckbox}
                  /*Не представлен в форме*/
                />
              </div>
              <div className="form-group">
                <Checkbox
                  id="defaultReserveOrders"
                  onChange={handleUpdateCheckbox}
                  checked={values.lite?.defaultReserveOrders}
                  label={'defaultReserveOrders'}
                />
              </div>
              <div className="form-group">
                <Checkbox
                  id="displayFinance"
                  onChange={handleUpdateCheckbox}
                  checked={values.lite?.displayFinance}
                  label={'displayFinance'}
                />
              </div>
              <div className="form-group">
                <Checkbox
                  id="enableBarcodeDuplicates"
                  checked={values.lite?.enableBarcodeDuplicates}
                  onChange={handleUpdateCheckbox}
                  label={'enableBarcodeDuplicates'}
                  /*Не представлен в форме*/
                />
              </div>
              <div className="form-group">
                <Checkbox
                  id="includePurchaseNotificationFiles"
                  checked={values.lite?.includePurchaseNotificationFiles}
                  onChange={handleUpdateCheckbox}
                  label={'includePurchaseNotificationFiles'}
                  /*Не представлен в форме*/
                />
              </div>
            </div>
          </div>
        </section>
        {values.lite?.menuCatalog && (
          <section>
            <h4 className="header-title">Меню-каталог</h4>
            <div className="row">
              <div className="col-6">
                <div className="form-group">
                  <InputWrapper
                    id="humanId"
                    label="humanId"
                    value={values.lite?.menuCatalog?.humanId}
                    onChange={(e) => handleChangeInput('humanId', e.target.value)}
                  />
                </div>
              </div>
              <div className="col-6">
                <div className="form-group">
                  <InputWrapper
                    id="name"
                    label="menuCatalog"
                    value={values.lite?.menuCatalog?.name}
                    onChange={(e) => handleChangeInput('name', e.target.value)}
                  />
                </div>
              </div>

              <div className="col-12">
                <div className="fixed-table-container">
                  <div className="fixed-table-body">
                    <table className="table table-centered">
                      <thead className="thead-light">
                        <tr>
                          <th>ID коллекции</th>
                          <th>Название</th>
                        </tr>
                      </thead>
                      <tbody>
                        {values.lite?.menuCatalog?.items.map((collection, i) => {
                          return (
                            <tr key={uuidv4()}>
                              <td>{collection.collectionId}</td>
                              <td>{collection.title}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            {/*Не стал отображать orderEmailFooter и orderEmailHeader - закодированные данные */}
            {/* //TODO: Возможность редактировать товары*/}
          </section>
        )}

        <section>
          <h4 className="header-title" style={{ marginTop: '16px' }}>
            Другие опции
          </h4>
          <div className="row">
            <div className="col-6">
              <div className="form-group">
                <Checkbox
                  id="needApiProductsReturnDetails"
                  onChange={handleUpdateCheckbox}
                  checked={values.lite?.needApiProductsReturnDetails}
                  label={'needApiProductsReturnDetails'}
                />
              </div>
              <div className="form-group">
                <Checkbox
                  id="ofertaAccepted"
                  checked={values.lite?.ofertaAccepted}
                  label={'ofertaAccepted'}
                  onChange={handleUpdateCheckbox}
                  /*Не представлен в форме*/
                />
              </div>
              <div className="form-group">
                <Checkbox
                  id="reportsUseDemoData"
                  onChange={handleUpdateCheckbox}
                  checked={values.lite?.reportsUseDemoData}
                  label={'reportsUseDemoData'}
                />
              </div>
              <div className="form-group">
                <Checkbox
                  id="tempBlockAccount"
                  checked={values.lite?.tempBlockAccount}
                  label={'tempBlockAccount'}
                  onChange={handleUpdateCheckbox}
                  /*Не представлен в форме*/
                />
              </div>
              <div className="form-group">
                <Checkbox
                  id="useCustomDlvTariffLogin"
                  onChange={handleUpdateCheckbox}
                  checked={values.lite?.useCustomDlvTariffLogin}
                  label={'useCustomDlvTariffLogin'}
                />
              </div>
              {/*              <div className="form-group">
                <Checkbox
                  id="useUpdateRegistryV2"
                  checked={values.lite?.useUpdateRegistryV2}
                  label={'useUpdateRegistryV2'}
                  onChange={handleUpdateCheckbox}

                />
              </div>
              <div className="form-group">
                <Checkbox
                  id="useWMSReturns"
                  checked={values.lite?.useWMSReturns}
                  label={'useWMSReturns'}
                  onChange={handleUpdateCheckbox}

                />
              </div>*/}
            </div>
          </div>
        </section>
      </>
    );
  };

  return (
    <form onKeyDown={preventSubmittingByEnter} onSubmit={handleSubmit}>
      <div className="border-bottom">
        <h4 className="header-title">Приватные настройки</h4>
      </div>
      {settings !== null && <div>{renderSettings(settings.objects[0])}</div>}
    </form>
  );
};

export default AdminSettings;
